import styled from 'styled-components';
import ModifyAddress from 'components/form/AddressSelector/Items/ModifyAddress/container';

export default styled(ModifyAddress)`
  padding: 0.2rem 1.2rem 1.2rem 1.2rem;

  button {
    background-color: var(--primary100);
    border: none;
  }
`;
